import { createUseStyles } from 'react-jss'

export default createUseStyles({
  button: {
    width: '100%',
    borderRadius: '0 !important',
    backgroundImage: ({ backgroundColor }) => backgroundColor
  },
  title: {
    fontSize: '18px'
  },
  container: {
    cursor: 'pointer',
    display: 'none',
    width: '100%',
    '@media (max-width: 667px)': {
      display: 'initial'
    }
  }
})
